import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoSliderLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoSlider" */ './PhotoSlider'), 'PhotoSliderLayout');
